import React, { Component } from 'react';
import DatePicker from 'react-date-picker'

class MyDatePicker extends Component {
  static defaultProps = {
    className: "",
    minDate: null,
    maxDate: null,
    value: new Date(),
    title: ""
  };

  render() {
    const { title, value, onChange, name, minDate, maxDate, className } = this.props;
    return (
      <React.Fragment>
        <div className={"row " + className}>
          {title}
        </div>
        <div className={"row text-dark " + className}>
          <DatePicker clearIcon={null}
                      minDate={minDate}
                      maxDate={maxDate}
                      locale={"es"}
                      value={value}
                      onChange={onChange}
                      maxDetail="month"
                      minDetail="year"
                      name={name}
                      className="bg-white w-100"/>
        </div>
        <div className="row mb-3">

        </div>
      </React.Fragment>
    );
  }
}

export default MyDatePicker;
